module.exports = __webpack_public_path__ + "static/media/1015781.f74370bf.png";